module.exports = __webpack_public_path__ + "img/cageddogs.30dc77c7.jpg";